import * as React from "react";
import PropTypes from 'prop-types';

const SvgWishlistFilledRed = props => {
  if (props.id !== "_svgwishlistfilledred") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" fill="none" {...props}><circle cx={20} cy={20} r={18} fill="#fff" fillOpacity={0.92} /><path fillRule="evenodd" clipRule="evenodd" d="M25.217 10C22.18 10 20 12.94 20 12.94S17.954 10 14.783 10c-1.593 0-3.176.66-4.334 1.767-1.414 1.35-2.42 3.168-2.448 5.141-.028 1.97.925 3.828 2.295 5.216l8.24 8.074c.415.42.892.802 1.464.802s1.184-.382 1.599-.804l8.243-8.073c1.37-1.39 2.186-3.246 2.157-5.215-.027-1.973-.896-3.793-2.31-5.143C28.53 10.66 26.81 10 25.216 10z" fill="#E71324" /></svg>;
};

SvgWishlistFilledRed.displayName = "_svgwishlistfilledred";
SvgWishlistFilledRed.propTypes = {
  id: PropTypes.string
};
SvgWishlistFilledRed.defaultProps = {
  id: ''
};
export default SvgWishlistFilledRed;